import Head from 'next/head'
import { useRouter } from 'next/router'

export function CustomHead({
  title = 'Modern Software Engineering',
  pageType = 'website',
  description = 'Custom software development for your needs. Front-end · Back-end · Mobile Development · DevOps · QA & Testing provided by a reliable tech company.',
  imagePath = '/images/about-us-head-image.webp',
}) {
  const router = useRouter()
  const SITE_NAME = 'Modsen'
  const DOMAIN = 'modsen-software.com'
  const URL = `https://${DOMAIN}${router.pathname}`
  const LOCALE = 'en_US'

  return (
    <Head>
      <title>{`${SITE_NAME} | ${title}`}</title>

      <meta property="og:url" content={URL} />
      <meta property="og:type" content={pageType} />
      <meta property="og:title" content={`${SITE_NAME} | ${title}`} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imagePath} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content={LOCALE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content={DOMAIN} />
      <meta property="twitter:url" content={URL} />
      <meta name="twitter:title" content={`${SITE_NAME} | ${title}`} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imagePath} />
    </Head>
  )
}
